<template>
    <div class="info-view" >

        <div
            class="info-panel"
            :class="{ 'is-open': objetTouristique }"
        >
            <button
                class="info-panel__close | close | btn btn--cta btn--rounded"
                role="button"
                @click="$emit('panel:close')"
            >
                <img src="/img/ui/icon-cross.svg" alt="Close" class="info-panel__close-icon | icon icon--close">
            </button>

            <div class="info-panel__inner" v-if="objetTouristique">
                <header
                    class="info-panel__header"
                >
                    <figure class="info-panel__fig">
                        <img
                            v-if="cover"
                            :src="cover.url"
                            class="info-panel__cover"
                        />
                        <figcaption class="info-panel__figcaption" v-if="cover" v-html="cover.copyright" />
                    </figure>
                    <div class="info-panel__header__content">
                        <h1 class="info-panel__title | title title--xl">{{ objetTouristique.libelle }}</h1>
                        <div class="info-panel__header__meta">
                            <strong class="info-panel__location">
                                <img src="/img/ui/icon-simple-marker.svg" alt="Location">
                                {{ objetTouristique.commune }}
                            </strong>
                        </div>
                    </div>
                </header>

                <div class="info-panel__meta">
                    <div class="list-descicons">
                        <div class="descicons" v-if="distance">
                            <img src="/img/ui/icon-distance.svg" alt="Distance">
                            <div class="descicons__inner">
                                <h2 class="title">{{ this.$root.trans.distanceTitle }}</h2>
                                <p>{{ this.$root.trans.distanceInfo.replace(':num', distance) }}</p>
                            </div>
                        </div>
                        <div class="descicons" v-if="duration">
                            <img src="/img/ui/icon-time.svg" alt="Temps">
                            <div class="descicons__inner">
                                <h2 class="title">{{ this.$root.trans.durationTitle }}</h2>
                                <p>{{ this.$root.trans.durationInfo.replace(':num', duration) }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="qrcode">
                        <img :src="objetTouristique.qrcode" alt="QR CODE" class="qrcode__img">
                        <strong>{{ this.$root.trans.scanQRCode }}</strong>
                    </div>
                </div>

                <div class="info-panel__content">
                    <p>{{ objetTouristique.description }}</p>

                    <div v-if="objetTouristique.ouverture">
                        <h3 class="gallery__title | title">{{ this.$root.trans.openingTimeTitle }}</h3>
                        <ul class="highlightedbox">
                            <li v-html="objetTouristique.ouverture"></li>
                        </ul>
                    </div>

                    <div v-if="objetTouristique.domaines.length">
                        <h3 class="gallery__title | title">{{ this.$root.trans.domainesTitle }}</h3>
                        <ul class="highlightedbox">
                            <li v-for="(domaine, i) in objetTouristique.domaines" :key="i" v-html="domaine"></li>
                        </ul>
                    </div>

                    <gallery
                        v-if="slideshow.length"
                        :illustrations="slideshow"
                    />

                </div>

                <footer class="info-panel__footer">
                    <img src="/img/ui/logo-apidae.jpg" alt="Apidae - L'information touristique">
                    <p>{{ this.$root.trans.footerInfoUpdatedBy.replace(':date', objetTouristique.updatedDate) }} {{ objetTouristique.proprietaire }}</p>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import Gallery from './Gallery.vue'

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'InfoPanel',

    components: {
        Gallery,
    },

    props: {
        objetTouristique: { type: Object, required: false },
    },

    data() {
        return {
        }
    },


    /* Life Cycle
    --------------------------------------------------------- */

    created() {
        //
    },


    mounted() {
        //
    },


    /* Data Handling
    --------------------------------------------------------- */


    computed: {
        cover() {
            return this.objetTouristique.illustrations[0]
        },

        slideshow() {
            return this.objetTouristique.illustrations.slice(1)
        },

        distance() {
            if (this.objetTouristique.direction && this.objetTouristique.direction.routes.length) {
                return this.objetTouristique.direction.routes[0].legs[0].distance.text
            }
            return null
        },

        duration()  {
            if (this.objetTouristique.direction && this.objetTouristique.direction.routes.length) {
                return this.objetTouristique.direction.routes[0].legs[0].duration.text
            }
            return null
        },
    },


    watch: {

    },


    /* Methods
    --------------------------------------------------------- */

    methods: {

        /* Handlers
        --------------------------------------------------------- */
    },
}
</script>
